import { render, staticRenderFns } from "./user-identification-item.vue?vue&type=template&id=281a1475&scoped=true"
import script from "./user-identification-item.vue?vue&type=script&lang=js"
export * from "./user-identification-item.vue?vue&type=script&lang=js"
import style0 from "./user-identification-item.vue?vue&type=style&index=0&id=281a1475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281a1475",
  null
  
)

export default component.exports